import { css } from '@spectrum-web-components/base';
const styles = css`
    :host{--spectrum-accordion-divider-color:var(--system-accordion-divider-color);--spectrum-accordion-item-content-disabled-color:var(--system-accordion-item-content-disabled-color);--spectrum-accordion-item-content-color:var(--system-accordion-item-content-color)}
`;
export default styles;